import "@/App.css";
import "@/lib/auth"; // Global axios interceptor for auth
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import PickSelection from "@/pages/PickSelection";
import Leaderboard from "@/pages/Leaderboard";
import OtherPicks from "@/pages/OtherPicks";
import BracketView from "@/pages/BracketView";
import Bracket from "@/pages/Bracket";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminGuide from "@/pages/AdminGuide";
import TalkSmack from "@/pages/TalkSmack";
import About from "@/pages/About";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { TournamentProvider } from "@/context/TournamentContext";
import CookieConsent from "@/components/CookieConsent";

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/picks"
          element={
            <ProtectedRoute>
              <PickSelection />
            </ProtectedRoute>
          }
        />
        <Route
          path="/leaderboard"
          element={
            <ProtectedRoute>
              <Leaderboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/other-picks"
          element={
            <ProtectedRoute>
              <OtherPicks />
            </ProtectedRoute>
          }
        />
        <Route
          path="/bracket"
          element={
            <ProtectedRoute>
              <BracketView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-bracket"
          element={
            <ProtectedRoute>
              <Bracket />
            </ProtectedRoute>
          }
        />
        <Route
          path="/about"
          element={
            <ProtectedRoute>
              <About />
            </ProtectedRoute>
          }
        />
        <Route
          path="/talk-smack"
          element={
            <ProtectedRoute>
              <TalkSmack />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-guide"
          element={
            <ProtectedRoute adminOnly>
              <AdminGuide />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TournamentProvider>
          <AppRouter />
          <CookieConsent />
        </TournamentProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;